import { render, staticRenderFns } from "./AddWorkstationPage.vue?vue&type=template&id=5a4eb1d5"
import script from "./AddWorkstationPage.vue?vue&type=script&lang=js"
export * from "./AddWorkstationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports